module.exports = { assertValidEvent: require('./assertValid').assertValidEvent };